module.exports = __webpack_public_path__ + "img/coupon-icon-1.5417b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/coupon-icon-1.png
// module id = 7O3+
// module chunks = 1